import {
  environment,
  forbidApiKeyDomains,
  isProductionUrl,
} from '@env/environment';
import { COMPANIES_USER_EMAILS_LIST } from '@services/utils/global-config';
import { isDevelopmentDomain } from '@services/utils/get-current-domain';


export class ApiKeyHandler {
  static companyAccountList = COMPANIES_USER_EMAILS_LIST;

  static areRealMapsChecked() {
    const realMapStorage = localStorage.getItem('stageRealMap');
    return JSON.parse(realMapStorage) === true;
  }

  static isApiKeyNeeded() {
    return isProductionUrl || ApiKeyHandler.areRealMapsChecked();
  }

  static isCompaniesUser() {
    const emailStorage = localStorage.getItem('email');

    return this.companyAccountList.includes(emailStorage)
  }

  static isCompaniesWithApiKey() {
    return ApiKeyHandler.isApiKeyNeeded() && ApiKeyHandler.isCompaniesUser();
  }

  static getApiKey(isLocation = false) {
    // RMT-2159 - const isProductionUserExceptCompanies = isProductionUrl && !ApiKeyHandler.isCompaniesUser(); was replaced with const isProduction = isProductionUrl && !isDevelopmentDomain();
    const isProduction = isProductionUrl && !isDevelopmentDomain();
    const isForbiddenApiKey = forbidApiKeyDomains.includes(location.origin);
    let apiKey: string | undefined;
    if (isForbiddenApiKey) {
      apiKey = environment.defaultKey;
    } else if (isProduction) {
      apiKey = environment.googleApiKey;
    } else if (isDevelopmentDomain() && ApiKeyHandler.areRealMapsChecked()) {
      apiKey = environment.googleApiKey;
    } else if (ApiKeyHandler.isCompaniesWithApiKey()) {
      /* Companies account for shrink and geofence  */
      apiKey = isLocation
        ? environment.companiesApiKey
        : environment.defaultKey;
    } else {
      /* Development + QA Instances + Companies account before shrink or geofence  */
      apiKey = environment.defaultKey;
    }

    return apiKey;
  }
}
